// ABOUTME: Configuration for the Software Errors/Notifications management page tabs.
// ABOUTME: Defines the tab structure for error and notification management.

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export const softwareErrorsConfig = {
    all: {
        title: 'all',
        icon: <ErrorOutlineIcon />,
    },
};
